import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header.js";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu.js';
import TopMenu from '../../../Components/TopMenu/TopMenu.js';

import { Button, Modal } from 'react-bootstrap';

import Driver from '../../Forwarder/DVRegistration/Driver.js';
import Visitor from '../../Forwarder/DVRegistration/Visitor.js';

const DVRegistration = () => {

    const initialTab = localStorage.getItem("Maintab") || 'driver';
    const [mainTab, setMainTab] = useState(initialTab);
    const isMounted = useRef(false);
    const [selectedButton, setSelectedButton] = useState(initialTab);

    useEffect(() => {
        setSelectedButton(initialTab);
    }, [initialTab]);

    const handleMainClick = (button) => {
        console.log('button',button);
        
        localStorage.removeItem('grid_tab');
        setMainTab(button);
        localStorage.setItem('Maintab', button);
    };

    return (
        <div className="">
            <Header page_type='fsm' logo_url='/DVRegistration' />
            <div className="page-body-wrapper schedule">
                {/* <LeftMenu /> */}
                <div className="main-panel rounded">
                    <div className="mainTab">
                        <TopMenu module='DVR' onTab={handleMainClick} selectedTab={mainTab}/>
                        <div className="">
                            <div className="allcontent-fl">
                                <div className='d-flex justify-content-between'>


                                </div>
                                <div className="lcontent">
                                    {/* {selectedButton == 'Driver' && <Driver onOpenModal={openModal} cModal={closeConfirm} />}
                                    {selectedButton == 'Visitor' && <Visitor oModal={openModal} cModal={closeConfirm} />} */}
                                    {mainTab === 'driver' &&
                                                <Driver
                                                    // DClick={() => handlenewLink('D')}
                                                    // PDClick={() => handlenewLink('PD')}
                                                    // PtClick={() => handlenewLink('PT')}
                                                    // stockClick={() => handlenewLink('', 'uldstock')}
                                                />
                                            }
                                    {mainTab === 'visitor' &&
                                        <Visitor
                                            // DClick={() => handlenewLink('D')}
                                            // AddClick={() => handlenewLink('AD')}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default DVRegistration